/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Deletedbyuserid3Inputs */

const en_entity_deletedbyuserid3 = /** @type {(inputs: Entity_Deletedbyuserid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted By User ID`)
};

const de_entity_deletedbyuserid3 = /** @type {(inputs: Entity_Deletedbyuserid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelöscht von Benutzer-ID`)
};

/**
* | output |
* | --- |
* | "Deleted By User ID" |
*
* @param {Entity_Deletedbyuserid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_deletedbyuserid3 = /** @type {((inputs?: Entity_Deletedbyuserid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Deletedbyuserid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_deletedbyuserid3(inputs)
	return de_entity_deletedbyuserid3(inputs)
});
export { entity_deletedbyuserid3 as "entity_deletedByUserId" }